<template>
  <div>
    <div class="text-center mt-12 mb-8 ml-2 mr-2">
      <h1 class="font-weight-regular">Планы развития для людей 🚀</h1>
    </div>
    <v-container>
      <v-row>
        <v-col
                :key=idx
                v-for="(roadmap, idx) in roadmaps"
                :cols="14">
          <v-hover v-slot:default="{ hover }">
            <v-card
                    class="mx-auto v-card--hover"
                    :outlined=outlined
                    :elevation="hover ? elevation * 2 : elevation"
                    :raised=raised
                    :width="width"
                    :height="height"
                    @click="toPlanBuilder(roadmap.slug)"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="title">{{roadmap.title}}</v-list-item-title>
                  <v-list-item-subtitle>by {{roadmap.authors.join(', ')}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: "Catalog",
    data() {
      return {
        outlined: true,
        elevation: 3,
        raised: true,
        width: 300,
        height: 80,
      }
    },
    computed: {
      roadmaps() { return this.$store.state.roadmaps; },
    },
    methods: {
      toPlanBuilder(roadmap_slug) {
        this.$router.push({name: 'planBuilder', params: {'slug': roadmap_slug}});
      }
    }
  }
</script>

<style scoped>

</style>
